<template>
    <div class='header'>
        <h1 class='titre'>{{$t('dashboard.parametrable.edition.titre')}}</h1>
        <ReglePastille cle="editionDashboard.glisserDeposer" />
        <ReglePastille cle="editionDashboard.widgetTaillesDifferentes" />
        <input v-model='libelleDashboard' class='input-libelle' maxlength='45' :aria-label="$t('dashboard.parametrable.edition.titre')">
        <ReglePastille cle="editionDashboard.renommageALaSortie" />
        <img :src='loadIconFavori' :alt='$t("dashboard.parametrable.modale.info.favori")' class='icons cursor-pointer' @click='mettreFavori'>
        <ReglePastille cle="dashboard.favoriIrreversibleIci" />
        <img :src='loadIconFilter' :alt='$t("dashboard.parametrable.ajout.dashbboard")' class='icons cursor-pointer' @click='modaleCreationDashboardOuverte = true' id='icone-filtre-edition-dashboard'>
        <img :src='loadIconDelete' :alt='$t("dashboard.parametrable.supprimer")' class='icons cursor-pointer' @click='supprimer'>
        <ReglePastille cle="dashboard.suppressionFavoriInterdite" />
        <div v-if='!enregistrementEnCours' class='icons enregistrement'>
            <img :src='loadIconCheckVert' alt='' aria-hidden="true">
            <span>{{$t('dashboard.parametrable.edition.enregistre')}}</span>
        </div>
        <div v-else class='icons enregistrement'>
            <img :src='loadIconWait' alt='' aria-hidden="true">
            <span>{{$t('dashboard.parametrable.edition.encours.enregistrement')}}</span>
        </div>
        <ReglePastille cle="editionDashboard.enregistrementAutomatique" />
        <div class="icon-info" id='icon-info-edtion'>
            <img :src='loadInfoIcon' id='image-info-edition' :alt='$t("dashboard.parametrable.edition.titre")' class="cursor-pointer" @click='startOnBoarding'>
            <div v-if='tooltipVisible' class="custom-tooltip">{{$t('dashboard.tooltip.edition')}}</div>
        </div>
        <button class='button-widget' @click='creerWidget' id='bouton-creer-widget'>
            <img :src='loadIconPlus' alt='' aria-hidden="true">
            {{$t('dashboard.parametrable.edition.ajouter.widget')}}
        </button>
        <ReglePastille cle="editionDashboard.widgetFacturationReserve" />
        <button class='button' @click='goDashboard' id='bouton-quitter-edition-dashboard'>
            <img :src='loadIconExit' alt='' aria-hidden="true">
            {{$t('dashboard.parametrable.edition.quitter')}}
        </button>
    </div>

    <div class="content">
            <div class="widget-container" id='edition-widget-container'>
                <draggable :list='listeWidget' class='draggable' @change="changerPosition">
                    <span v-for='widget in listeWidget' :key='widget.id' :class='widget.typeWidgetId === 2 ? "width-65pct" : "width-32pct"' id='edition-widget-span'>
                        <EditionDemandeIntervention
                            v-if='widget.typeWidgetId === 1'
                            :widget='widget'
                            @filtre='modifierFiltreWidget(widget)'
                            @dupliquer='dupliquerWidget(widget)'
                            @suppression='supprimerWidget(widget)'
                            class='third' />
                        <EditionPreventive
                            v-if='widget.typeWidgetId === 2'
                            :widget='widget'
                            @filtre='modifierFiltreWidget(widget)'
                            @dupliquer='dupliquerWidget(widget)'
                            @suppression='supprimerWidget(widget)'
                            class='twoThirds'/>
                        <EditionPreventiveOut
                            v-if='widget.typeWidgetId === 3'
                            class='third'
                            :widget='widget'
                            @filtre='modifierFiltreWidget(widget)'
                            @dupliquer='dupliquerWidget(widget)'
                            @suppression='supprimerWidget(widget)'/>
                        <EditionEstimate
                            v-if='widget.typeWidgetId === 4'
                            class='third'
                            :widget='widget'
                            @filtre='modifierFiltreWidget(widget)'
                            @dupliquer='dupliquerWidget(widget)'
                            @suppression='supprimerWidget(widget)'/>
                        <EditionBilling
                            v-if="widget.typeWidgetId === 5"
                            class='third'
                            :widget='widget'
                            @filtre='modifierFiltreWidget(widget)'
                            @dupliquer='dupliquerWidget(widget)'
                            @suppression='supprimerWidget(widget)'/>
                    </span>
                </draggable>
                <div class="empty-widget-space">
                    <button class='button-add button-widget' @click='creerWidget' :aria-label="$t('dashboard.parametrable.edition.ajouter.widget')">
                        <img :src='loadIconPlus' alt='' aria-hidden="true">
                    </button>
                </div>
            </div>
    </div>

    <div class='height-2pct'></div>

    <Modal v-if='modaleAlerte' @cancel='modaleAlerte = false'>
        <div class='container-modale'>
            {{texteAlerte}}
        </div>
    </Modal>

    <Modal v-if='modaleCreationDashboardOuverte' @cancel='modaleCreationDashboardOuverte = false'>
        <ModaleCreationDashboard
            :is-only-for-site='true'
            @creation-dashboard-success='modaleCreationDashboardOuverte = false'
            @cancel='modaleCreationDashboardOuverte = false'
        ></ModaleCreationDashboard>
    </Modal>

    <Modal v-if='modaleWidgetOuverte || isModaleForceOpen' @cancel='modaleWidgetOuverte = false'>
        <ModaleCreationWidget
            :widget-a-dupliquer='widgetADupliquer'
            :widget-a-modifier='widgetAModifier'
            @ajout-widget='ajouterWidget'
            @cancel='modaleWidgetOuverte = false'
        ></ModaleCreationWidget>
    </Modal>
</template>

<script lang="ts">
import { defineComponent, nextTick } from 'vue';
import { VueDraggableNext } from 'vue-draggable-next';
import EditionPreventiveOut from '@/modules/Home/components/EditionPreventiveOut.vue';
import { HomeAction } from '@/modules/Home/store/actions-types';
import EditionPreventive from '@/modules/Home/components/EditionPreventive.vue';
import Modal from '@/components/ui-components/Modal.vue';
import router from '@/router';
import { HOME } from '@/modules/Home/store/mutation-types';
import ModaleCreationDashboard from '@/modules/Home/components/ModaleCreationDashboard.vue';
import ModaleCreationWidget from '@/modules/Home/components/ModaleCreationWidget.vue';
import { Widget } from '@/models/Widget';
import EditionDemandeIntervention from '@/modules/Home/components/EditionDemandeIntervention.vue';
import EditionEstimate from '@/modules/Home/components/EditionEstimate.vue';
import EditionBilling from '@/modules/Home/components/EditionBilling.vue';
import { MENU } from '@/components/layout/store/mutation-types';
import TourService from '@/common/utils/TourService';
import ReglePastille from '@/components/regles/ReglePastille.vue';

interface Data {
    libelleDashboard: string;
    texteAlerte: string;
    modaleAlerte: boolean;
    modaleCreationDashboardOuverte: boolean;
    modaleWidgetOuverte: boolean;
    widgetAModifier: Widget | undefined;
    widgetADupliquer: Widget | undefined;
    tourEnCours: boolean;
    tooltipVisible: boolean;
}

export default defineComponent({
    name: 'EditionDashboard',
    components: {
        EditionEstimate,
        EditionDemandeIntervention,
        ModaleCreationWidget,
        ModaleCreationDashboard,
        Modal,
        EditionPreventive,
        EditionPreventiveOut,
        EditionBilling,
        draggable: VueDraggableNext,
        ReglePastille,
    },
    data(): Data {
        return {
            libelleDashboard: '',
            texteAlerte: '',
            modaleAlerte: false,
            modaleCreationDashboardOuverte: false,
            modaleWidgetOuverte: false,
            widgetAModifier: undefined,
            widgetADupliquer: undefined,
            tourEnCours: false,
            tooltipVisible: true,
        };
    },
    beforeMount() {
        if (this.$store.getters.getSelectedDashboard === undefined) {
            this.$router.push({ path: '/dashboard' });
        }
        this.libelleDashboard = this.$store.getters.getSelectedDashboard.libelle;
        document.addEventListener('click', this.close);
    },
    computed: {
        loadIconFavori() {
            if (this.$store.getters.getSelectedDashboard !== undefined && this.$store.getters.getSelectedDashboard.favori) {
                return require('@/assets/img/icons/favoriVioletRempli.png');
            }
            return require('@/assets/img/icons/favoriVioletVide.png');
        },
        loadIconFilter() {
            return require('@/assets/img/icons/filter.png');
        },
        loadIconDelete() {
            return require('@/assets/img/icons/bin.png');
        },
        loadIconCheckVert() {
            return require('@/assets/img/icons/checkVert.png');
        },
        enregistrementEnCours() {
            return this.$store.getters.getEnregistrementsDashboardEnCours;
        },
        loadIconWait() {
            return require('@/assets/img/icons/wait.png');
        },
        loadIconExit() {
            return require('@/assets/img/icons/exit.png');
        },
        loadIconPlus() {
            return require('@/assets/img/icons/plusBlanc.png');
        },
        listeWidget(): Widget[] {
            if (this.$store.getters.getSelectedDashboard.widgets == undefined) {
                return [];
            }
            return [...this.$store.getters.getSelectedDashboard.widgets]
                .sort((a: Widget, b: Widget) => a.position - b.position);
        },
        isModaleForceOpen(): boolean {
            return this.$store.getters.isModaleWidgetForceOuverte;
        },
        loadInfoIcon() {
            return require('@/assets/img/info_24dp.png');
        },
    },
    methods: {
        startOnBoarding() {
            this.tourEnCours = true;
            this.$store.commit(`menuState/${MENU.SET_ONBOARDING_OPEN}`, true);
            this.tooltipVisible = false;
            this.startTour();
        },
        startTour() : void {
            nextTick(() => {
                this.$store.commit(HOME.OPEN_MODAL_WIDGET, true);

                    nextTick(() => {
                        const modal = document.querySelector('.modal-content') as HTMLElement;
                        const modalContainer = document.querySelector('.modal-container') as HTMLElement;

                        if (modal) {
                            modal.style.display = 'none';
                        }

                        if (modalContainer) {
                            modalContainer.style.zIndex = '1';
                        }

                        TourService.initTour(
                            this.$t('button.previous'),
                            this.$t('button.close'),
                            this.$t('button.next'),
                            () => {
                                this.tourEnCours = false;
                                this.$store.commit(`menuState/${MENU.SET_ONBOARDING_OPEN}`, false);
                                this.$store.commit(HOME.OPEN_MODAL_WIDGET, false);
                            });

                        TourService.addStep(
                            this.$t('dashboard.step.sites'),
                            '#icone-filtre-edition-dashboard',
                            'top',
                            true,
                            false,
                            true,
                        );

                        TourService.addStep(
                            this.$t('dashboard.step.add_widget'),
                            '#bouton-creer-widget',
                            'bottom',
                            true,
                            false,
                            true,
                            () => {
                                const modal = document.querySelector('.modal-content') as HTMLElement;
                                if (modal) {
                                    modal.style.display = 'block';
                                }
                            }
                        );

                        TourService.addStep(
                            this.$t('dashboard.step.config_widget'),
                            '#creation-widget-step-bar',
                            'bottom',
                            true,
                            false,
                            true,
                            () => {
                                const modal = document.querySelector('.modal-content') as HTMLElement;
                                if (modal) {
                                    modal.style.display = 'none';
                                }
                                if (modalContainer) {
                                    modalContainer.style.display = 'none';
                                }
                            }
                        );

                        TourService.addStep(
                            this.$t('dashboard.step.drag_drop'),
                            '#edition-widget-span',
                            'bottom',
                            true,
                            false,
                            true,
                        );

                        TourService.addStep(
                            this.$t('dashboard.step.finish'),
                            '#bouton-quitter-edition-dashboard',
                            'bottom',
                            true,
                            true,
                            true,
                        );

                        TourService.startTour();

                    });

            });
        },
        creerWidget() {
            this.modaleWidgetOuverte = true;
            this.widgetAModifier = undefined;
            this.widgetADupliquer = undefined;
        },
        async changerPosition(event: any) {
            const widget : Widget = this.$store.getters.getSelectedDashboard.widgets.find((widget: Widget) => widget.id === event.moved.element.id);

            const widgetImpacte : Widget = this.$store.getters.getSelectedDashboard.widgets.find((w: Widget) => w.position === event.moved.newIndex);
            this.$store.commit(HOME.SET_WIDGET_POSITION, {widgetPosition: event.moved.oldIndex, widget: widgetImpacte});
            this.$store.commit(HOME.SET_WIDGET_POSITION, {widgetPosition: event.moved.newIndex, widget: widget});

            await this.$store.dispatch(HomeAction.CHANGE_WIDGET_POSITION, {widget: widget, nouvellePosition: event.moved.newIndex});
        },
        async mettreFavori() {
            if (this.$store.getters.getSelectedDashboard !== undefined) {
                if (this.$store.getters.getSelectedDashboard.favori) {
                    this.modaleAlerte = true;
                    this.texteAlerte = this.$t('dashboard.parametrable.modale.info.favori');
                } else {
                    this.$store.getters.getSelectedDashboard.favori = true;
                    await this.$store.dispatch(HomeAction.PUT_DASHBOARD, this.$store.getters.getSelectedDashboard);
                }
            }
        },
        goDashboard() {
            if (this.libelleDashboard !== '' && this.libelleDashboard !== this.$store.getters.getSelectedDashboard.libelle) {
                this.$store.commit(HOME.SET_LIBELLE_DASHBOARD, this.libelleDashboard);
                this.$store.dispatch(HomeAction.SET_DASHBOARD, this.$store.getters.getSelectedDashboard);
            }
            router.push({ path: '/dashboard' });
        },
        async supprimer() {
            if (this.$store.getters.getSelectedDashboard !== undefined && this.$store.getters.getSelectedDashboard.favori) {
                this.modaleAlerte = true;
                this.texteAlerte = this.$t('dashboard.parametrable.modale.info.suppression.favori');
            }
            if (this.$store.getters.getSelectedDashboard !== undefined && !this.$store.getters.getSelectedDashboard.favori) {
                await this.$store.dispatch(HomeAction.DELETE_DASHBOARD, this.$store.getters.getSelectedDashboard);
                router.push({ path: '/dashboard' });
            }
        },
        ajouterWidget() {
            this.modaleWidgetOuverte = false;
            this.$store.commit(HOME.OPEN_MODAL_WIDGET, false);
            this.$store.dispatch(HomeAction.GET_DASHBOARD, this.$store.getters.getSelectedDashboard.id);
        },
        modifierFiltreWidget(widget: Widget) {
            this.widgetADupliquer = undefined;
            this.modaleWidgetOuverte = true;
            this.widgetAModifier = widget;
        },
        dupliquerWidget(widget: Widget) {
            this.widgetAModifier = undefined;
            this.widgetADupliquer = widget;
            this.modaleWidgetOuverte = true;
        },
        async supprimerWidget(widget: Widget) {
            await this.$store.dispatch(HomeAction.DELETE_WIDGET, widget);
            await this.$store.dispatch(HomeAction.GET_DASHBOARD, this.$store.getters.getSelectedDashboard.id);
        },
        close(e: any) {
            if (this.tourEnCours) {
                return;
            }

            // Gestion du tooltip info
            if (this.tooltipVisible) {
                const infoIcon = document.querySelector('#image-info-edition');
                const tooltipWrapper = document.querySelector('#icon-info-edtion');

                if (e.target !== infoIcon && !infoIcon?.contains(e.target) && (!tooltipWrapper || !tooltipWrapper.contains(e.target))) {
                    this.tooltipVisible = false;
                }
            }
        },
    },
});
</script>

<style scoped>
.content{
    box-sizing: border-box;
    display: flex;
    height: 100%;
    overflow-y: auto;
}
@media screen and (min-width: 980px) {
    .content{
        display: block;
        padding: 3vh 20px;
    }
}
@media screen and (min-width: 980px) {
    .widget-container{
        height: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        row-gap: 20px;
    }
}
@media (max-width: 1000px) {
    .widget-container{
        margin-right: auto;
        margin-left: auto;
        justify-content: flex-start;
        row-gap: 20px;
    }
}
@media (min-width: 980px) and (max-width: 1005px){
    .widget-container{
        height: auto;
        flex-flow: column wrap;
        justify-content: flex-start;
        row-gap: 20px;
    }
}
.draggable{
    display: contents;
}
.header {
    background-color: white;
    display: flex;
    align-items: center;
}
.titre {
    margin-left: 30px;
}
:deep(.card) {
    height: 55%;
}
.input-libelle {
    border: 1px solid #121A7A;
    border-radius: 8px;
    height: 30px;
    margin-left: 25px;
    margin-right: 15px;
    width: 300px;
}
.icons {
    margin-right: 10px;
    margin-left: 10px;
}
.enregistrement {
    display: flex;
    align-items: center;
}
.container-modale {
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 1px 5px rgba(0, 0, 0, 0.12);
    padding: 30px 30px 15px 30px;
}
.button {
    background-color: white;
    border: 2px solid #121A7A;
    border-radius: 8px;
    color: #121A7A;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    cursor: pointer;
}
.button-widget {
    cursor: pointer;
    background-color: var(--bleu-clair);
    border: 2px solid var(--bleu-clair);
    border-radius: 8px;
    color: white;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    margin-right: 20px;
}
.icon-info {
    margin-left: auto;
    padding: 5px 10px;
}
.header .button {
    margin-right: 20px;
}
.empty-widget-space {
    background-color: white;
    width: 32%;
    height: 55%;
    border-radius: 10px;
    margin-left: 1%;
    order: 1;
}
.draggable > span {
    order: 0;
    margin-left: 1%;
}
.button-add {
    border-radius: 20px;
    width: 40px;
    display: flex;
    justify-content: center;
    margin: 25% auto auto;
}
.width-32pct {
    width: 32%;
    height: 55%;
}
.width-65pct {
    width: 65%;
    height: 55%;
}
.twoThirds {
    height: 100%;
    width: 100%;
}
.third {
    height: 100%;
    width: 100%;
}
.height-2pct {
    height: 2%;
}
/* Repositionnement du tooltip pour éviter qu'il sorte de l'écran */
.icon-info .custom-tooltip {
    right: 408px;
    top: 18px;
}
</style>
